import { SafeUrl } from "@angular/platform-browser";
import { MarvDateService } from '@marv/services';
import { LogaProxy, TypeOfMission } from "@app/models";

export class Operation {

    static FromJson(json: any): Operation {
        const o: Operation = new Operation();

        o.id = json['id'];
        o.code = json['code'];
        o.name = json['name'].trim();
        o.start = new Date(json['start']);
        o.end = new Date(json['end']);
        o.startDayPlanning = json['startDayPlanning'];
        o.endDayPlanning = json['endDayPlanning'];
        o.uiDaysBeforePlanningClosing = (typeof json['uiDaysBeforePlanningClosing'] !== undefined ? json['uiDaysBeforePlanningClosing'] : null);
        o.uiIsPlanningClosed = json['uiIsPlanningClosed'];
        o.agency = json['agency'];
        o.agencyManager = json['agencyManager'];
        o.customerBU = json['customerBU']
        o.kits = json['merchandisingKits'];
        o.operationProfils = json['operationProfils'];
        o.typeOfMission = json['typeOfMission'];
        o.globalQuota = json['globalQuota'];
        o.quotaTotal = json['quotaTotal'];
        o.quotaRealized = json['quotaRealized'];
        o.quotaPlanned = json['quotaPlanned'];
        o.quotaRemaining = json['quotaRemaining'];

        return o;
    }

    id: number;
    code: string;
    name: string;
    start: Date;
    end: Date;
    startDayPlanning: number;
    endDayPlanning: number;
    
    uiDaysBeforePlanningClosing: number|null = null;
    uiIsPlanningClosed: boolean;

    agency: Agency;
    agencyManager: AgencyManager;
    typeOfMission: TypeOfMission;
    customerBU: CustomerBU;

    operationProfils: OperationProfil[];
    kits: Kit[];

    globalQuota: number;
    quotaTotal: number;
    quotaRealized: number;
    quotaPlanned: number;
    quotaRemaining: number;
    
    /**
     * keep only the active Operation Profiles
     */
    listActiveProfiles(): OperationProfil[] {
        let a: OperationProfil[] = [];
        for (let op of this.operationProfils)
            if (!op.inactive){
                a.push(op);
            }
        return a;
    }

    findActiveKits() {
        if (this.kits != null){
            return this.kits.filter(a => !a.inactive)
        }
        return [];
    }
}

export class Kit {
    id: number;
    code: string;
    name: string;
    inactive: boolean;
}

export class OperationProfil {
    id: number;
    code: string;
    name: string;
    inactive: true;
}

export class Agency {
    id: number;
    code: string;
    name: string;
}

export class AgencyManager {
    id: number;
    code: string;
    name: string;
}

export class CustomerBU {

    static FromJson(json: any): CustomerBU {
        const o: CustomerBU = new CustomerBU();

        o.id = json['id'];
        o.code = json['code'];
        o.name = json['name'];

        return o;
    }

    id: number;
    code: string;
    name: string;
}

export class MissionPlanningPurposes {
    
    id: number;
    code: string;
    name: string;
    recommendedDurationInMinutes: number|null;
    rank: number;
    disabled: boolean;
    
    static FromJson(o: any): MissionPlanningPurposes{
        let m = new MissionPlanningPurposes();
        m.id = o.id;
        m.code = o.code;
        m.name = o.name;
        m.recommendedDurationInMinutes = o.recommendedDurationInMinutes;
        m.rank = o.rank;
        m.disabled = o.disabled;
        return m;
    }
}

export class MerchImplementationOption {
    id: number;
    code: string;
    name: string;
    suggestedNbOfAgents: number;
    nbElements: number;
    ranking: number;
    
    static FromJson(o: any) : MerchImplementationOption {
        let m = new MerchImplementationOption();
        m.id = o.id;
        m.code = o.code;
        m.name = o.name;
        m.suggestedNbOfAgents = o.suggestedNbOfAgents;
        m.nbElements = o.nbElements;
        m.ranking = o.ranking;
        return m;
    }
}

export class OperationCustomerPlanningSetting {

    /**description of the operation to be displayed to the customer, to help him understand the goal of the operation, from his perspective")**/
    operationCustomerDescription: string;

    /**
     * To use or not day off
     */
    avoidDayOffInPlanning: boolean;

    /**
     * To show or hide customer feedback
     */
    hideCustomerFeedback: boolean;

    /**
     * Number of consecutive days in customer planning , 2 days exactly for eg
     * (Monday following Tuesday and not Monday Wednesday...)
     */
    nbOfConsecutivePlannedDays: number;

    /**
     * Delai de planification minimal
     */
    maxDaysAheadPlanning: number;

    /**
     * The duration for one mission , exactly this value
     */
    mandatoryMissionDurationInHours: number;

    /**
     * Delai de planification minimal (avec approbation client)
     */
    needCustomerApprovalPlannedBefore: number;


    //default AM start time for Mission to plan
    amStartTime: number;

    /**default AM end time for Mission to plan**/
    amEndTime: number;

    /**default PM start time for Mission to plan**/
    pmStartTime: number;

    /**default PM end time for Mission to plan**/
    pmEndTime: number;

    /**starting this date, the customer can start to plan for this operation**/
    planningOpenFrom: number;
    /**starting this date, the customer can no longer plan for this operation**/
    planningOpenUntil: number;

    /**earliest date the user can use to plan**/
    earliestPlannableDate: number;

    /**latest date the user can use to plan**/
    latestPlannableDate: number;

    /**display Presence Check basic information on LOCUPA / planning application **/
    showPresenceCheckInfos: boolean;

    /**CheckIn Questionnaire (controle de presence) visibility policy to be observed by LOCUPA / planning application")**/
    showCheckInQuestionnaire: string;

    /**Cra visibility policy to be observed by LOCUPA / planning application**/
    showCra: string;

    /**
     * Le client a accès aux informations de facturation
     */
    showInvoicingInfos: boolean;

    /**
     *If true the customer would be allowed to select a Kit at planning, if false, the kit will not be shown at all (view/create)
     */
    choseKitOnCustomerMissionPlaning: boolean;

    /**
     *
     */
    useSlotPlanning: boolean;

    shareAssignedWorkerInfoByEmail: boolean;

    /**
     * if true the user must be allowed to select several purpose when planning a new mission
     */
    useMultiPurposePlanning: boolean;
    missionPlanningPurposes: MissionPlanningPurposes[] = [];
    
    enforcePurposeRecommendedDuration: boolean;    
    merchImplementationOptions: Array<MerchImplementationOption> = [];
    
    mandatoryMissionPurposeOnPlanning: boolean;

    hasTimeFix(): boolean {
        return this.amStartTime != null && this.amEndTime != null && this.pmStartTime != null && this.pmEndTime != null;
    }

    setup(src: OperationCustomerPlanningSetting) {
        this.operationCustomerDescription = src.operationCustomerDescription;
        this.avoidDayOffInPlanning = src.avoidDayOffInPlanning;
        this.hideCustomerFeedback = src.hideCustomerFeedback;
        this.nbOfConsecutivePlannedDays = src.nbOfConsecutivePlannedDays;
        this.maxDaysAheadPlanning = src.maxDaysAheadPlanning;
        this.mandatoryMissionDurationInHours = src.mandatoryMissionDurationInHours;
        this.needCustomerApprovalPlannedBefore = src.needCustomerApprovalPlannedBefore;
        this.amStartTime = src.amStartTime;
        this.amEndTime = src.amEndTime;
        this.pmStartTime = src.pmStartTime;
        this.pmEndTime = src.pmEndTime;
        this.planningOpenFrom = src.planningOpenFrom;
        this.planningOpenUntil = src.planningOpenUntil;
        this.earliestPlannableDate = src.earliestPlannableDate;
        this.latestPlannableDate = src.latestPlannableDate;
        this.showPresenceCheckInfos = src.showPresenceCheckInfos;
        this.showCheckInQuestionnaire = src.showCheckInQuestionnaire;
        this.showCra = src.showCra;
        this.showInvoicingInfos = src.showInvoicingInfos;
        this.choseKitOnCustomerMissionPlaning = src.choseKitOnCustomerMissionPlaning;
        this.useSlotPlanning = src.useSlotPlanning;
        this.shareAssignedWorkerInfoByEmail = src.shareAssignedWorkerInfoByEmail;
        this.useMultiPurposePlanning = src.useMultiPurposePlanning;
        this.enforcePurposeRecommendedDuration = src.enforcePurposeRecommendedDuration;
        this.mandatoryMissionPurposeOnPlanning = src.mandatoryMissionPurposeOnPlanning;

        if (src.missionPlanningPurposes != null){
            src.missionPlanningPurposes.forEach(p => {   
                if(!p.disabled){
                    this.missionPlanningPurposes.push(MissionPlanningPurposes.FromJson(p));
                }
            });
            this.missionPlanningPurposes.sort((a, b) => a.rank - b.rank);
        }
        
        if(src.merchImplementationOptions != null){
            src.merchImplementationOptions.forEach(p => {   
                this.merchImplementationOptions.push(MerchImplementationOption.FromJson(p));
            });
            this.merchImplementationOptions.sort((a, b) => a.ranking - b.ranking);
        }
        
        return this;
    }
}

export class OperationHourlyQuota {
    availableQuota: number;
    consumedAndPlannedQuota: number;
    consumedAndRealisedQuota: number;
    consumedQuota: number;
    quotaAllowance: number;
}

export class OperationCard {

    id: number;
    code: string;
    name: string;
    start: Date;
    type: string;

    operationCustomerDescription: string;

    typeOfMissionName: string;
    typeOfMissionCode: string;

    rolDefinitionName: string;
    operationLogoUrl: string|SafeUrl;
    customerCode: string;
    customerName: string;
    emailManager: string;
    urlDashboard: string;

    agencyOperationManager: AgencyContact;

    kpiSheets: KpiSheet[];

    nbKits: number;
    logaWorkDayId: number;

    planningOpenFrom: number;
    planningOpenUntil: number;
    earliestPlannableDate: number;
    latestPlannableDate: number;
    showInvoicingInfos: boolean;
    useSlotPlanning: boolean;

    urlPhoto: string;
    quotaGlobal: number;
    quotaTotal: number;
    quotaRealized: number;
    quotaPlanned: number;
    quotaRemaining: number;
    
    hourlyQuota: OperationHourlyQuota;

    /**do we have a quota defined, on sectors, using a hour per profile stategy **/
    hourQuotaDefined: boolean;

    /**do we have a quota defined, on sectors, using a budget/euro per sector allowance strategy **/
    budgetQuotaDefined: boolean;

    /** if true, then the operation budget for quota should not be expressed in Euros, but in points, API will do the conversion**/
    budgetQuotaInPoints: boolean;

    /**
     * flag to tell if this campagn is really time bound, from a customer planning perspective
     */
    uiUsePlanning: boolean;

    /**
     * is the operation currently active, based on activites planned 2weeks in the past, and 2 months ahead
     */
    currentlyActive: boolean;

    /**
     * how many days before planning is no longer available
     */     
    uiDaysBeforePlanningOpening: number|null = null;
    uiIsPlanningOpened: boolean = false;
    uiDaysBeforePlanningClosing: number|null = null;
    uiIsPlanningClosed: boolean = false;
    
    uiSelected: boolean;

    toggleSelected() {
        this.uiSelected = this.uiSelected ? !this.uiSelected : true;
    }

    /**
     * setup from DTO to real instance
     * @param c
     */
    static FromJson(json: any): OperationCard {
        let operationCard = new OperationCard();
        operationCard.id = json.id;
        operationCard.code = json.code;
        operationCard.name = json.name;
        operationCard.start = json.start;
        operationCard.type = json.type;
        operationCard.rolDefinitionName = json.rolDefinitionName;
        operationCard.operationLogoUrl = json.operationLogoUrl;
        operationCard.customerCode = json.customerCode;
        operationCard.customerName = json.customerName;
        operationCard.emailManager = json.emailManager;
        operationCard.urlDashboard = json.urlDashboard;
        operationCard.kpiSheets = json.kpiSheets;
        operationCard.nbKits = json.nbKits;
        operationCard.logaWorkDayId = json.logaWorkDayId;
        operationCard.urlPhoto = json.urlPhoto;
        operationCard.quotaGlobal = json.quotaGlobal;
        operationCard.quotaTotal = json.quotaTotal;
        operationCard.quotaRealized = json.quotaRealized;
        operationCard.quotaPlanned = json.quotaPlanned;
        operationCard.quotaRemaining = json.quotaRemaining;
        operationCard.agencyOperationManager = json.agencyOperationManager;
        operationCard.typeOfMissionName = (json.type === 'lgg' ? 'PERMANENT' : json.typeOfMissionName);        
        operationCard.typeOfMissionCode = (json.type === 'lgg' ? 'PERM' : json.typeOfMissionCode);
        operationCard.planningOpenFrom = json.planningOpenFrom;
        operationCard.planningOpenUntil = json.planningOpenUntil;
        operationCard.earliestPlannableDate = json.earliestPlannableDate;
        operationCard.latestPlannableDate = json.latestPlannableDate;
        operationCard.operationCustomerDescription = json.operationCustomerDescription;
        operationCard.currentlyActive = json.currentlyActive;
        operationCard.showInvoicingInfos = json.showInvoicingInfos;
        operationCard.useSlotPlanning = json.useSlotPlanning;     
           
        operationCard.budgetQuotaDefined = json.budgetQuotaDefined;
        operationCard.hourQuotaDefined = json.hourQuotaDefined;
        operationCard.budgetQuotaInPoints = json.budgetQuotaInPoints;
        
        if(json.hourQuotaDefined && json.hourlyQuota){
            operationCard.hourlyQuota = {
                availableQuota: json.hourlyQuota.availableQuota,
                consumedAndPlannedQuota: json.hourlyQuota.consumedAndPlannedQuota,
                consumedAndRealisedQuota: json.hourlyQuota.consumedAndRealisedQuota,
                consumedQuota: json.hourlyQuota.consumedQuota,
                quotaAllowance: json.hourlyQuota.quotaAllowance
            };
        }

        // process business fields
        operationCard.uiUsePlanning = (operationCard.planningOpenFrom != null && operationCard.planningOpenFrom > 0) || (operationCard.planningOpenUntil != null && operationCard.planningOpenUntil > 0) || (operationCard.earliestPlannableDate != null && operationCard.earliestPlannableDate > 0) || (operationCard.latestPlannableDate != null && operationCard.latestPlannableDate > 0);
        
        const today = MarvDateService.GetToday();
        
        if (operationCard.planningOpenFrom !== null && operationCard.planningOpenFrom > 0) {
            let today = MarvDateService.GetToday();
            operationCard.uiDaysBeforePlanningOpening = Math.ceil(operationCard.planningOpenFrom - today);
            operationCard.uiIsPlanningOpened = operationCard.uiDaysBeforePlanningOpening <= 0;            
        }
        
        if (operationCard.planningOpenUntil != null && operationCard.planningOpenUntil > 0) {
            operationCard.uiDaysBeforePlanningClosing = Math.ceil(operationCard.planningOpenUntil - today);
            operationCard.uiIsPlanningClosed = operationCard.uiDaysBeforePlanningClosing < 0;            
        }
        
        return operationCard;
    }
    
}

export class AgencyContact {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
}

export class KpiSheet {
    id: number;
    name: string;
}

export class PermanentOperation {
    id: number;
    title: string;
    logo?: string|SafeUrl;
    
    static FromJson(json: any): PermanentOperation {
        let o = new PermanentOperation();
        o.id = json["value"];
        o.title = json["title"];
        return o;
    }
}

export class PermanentAgent {
    id: number;
    name: string;    
    planningRate7Days: number;  
    planningRate15Days: number;      
    
    static FromJson(json: any): PermanentAgent {
        let a = new PermanentAgent();
        a.id = json["value"];
        a.name = json["title"];
//        a.planningRate7Days = Math.floor(Math.random() * 101); // A MODIFIER - A ajouter dans l'API
//        a.planningRate15Days = Math.floor(Math.random() * 101); // A MODIFIER - A ajouter dans l'API
        return a;
    }
}